module.exports = __webpack_public_path__ + "img/img_hover.ea9f85cf.svg";